import React, { useEffect } from "react";

import { useSelector } from "react-redux";

import { useParams } from "react-router-dom";

import { convertToSlug } from "../../utils/helps";

import { Link } from "react-router-dom";

import { HomeIcon } from "@heroicons/react/24/outline";

import ActivitiesArticleBoxByCategory from "../../components/client/ActivitiesArticleBoxByCategory";

import ActivitiesButtonTitle from "../../components/ActivitiesButtonTitle";

const ABOUT_POST_SLUGS = [
  "qua-trinh-hinh-thanh-va-phat-trien",
  "thu-ngo-cua-chu-tich-hoi",
  "co-cau-to-chuc",
  "dieu-le-hoi",
  "quy-che-hoat-dong-cua-hoi",
  "quy-che-hoat-dong-ban-chap-hanh",
  "quy-che-chi-tieu-noi-bo",
];

function News({
  categoryType,
  pageTitle = "Tin tức và sự kiện",
  currentMonthOnly = false,
}) {
  const posts =
    useSelector((state) =>
      state.posts?.posts

        ?.filter(
          (post) =>
            post.status === "published" &&
            post.category?.slug !== "chinh-sach" &&
            !ABOUT_POST_SLUGS.includes(post.slug) &&
            post.slug !== "dieu-khoan",
        )

        ?.filter(
          (post) =>
            post.category?.name !== "Điều khoản" ||
            post.category?.name !== "Giới thiệu",
        ),
    ) || [];

  const { navbars } = useSelector((state) => state.categories);

  const { slug } = useParams();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const currentMonth = new Date().getMonth() + 1;

  const categoryTypeItems = categoryType
    ? navbars.filter((item) => item.type === categoryType)
    : [];

  const isPostInCurrentMonth = (post) => {
    const dateValue =
      post?.approvedAt ||
      post?.createdAt ||
      post?.created_at ||
      post?.publishedAt ||
      post?.updatedAt ||
      post?.updated_at;

    if (!dateValue) return false;

    const postDate = new Date(dateValue);

    const now = new Date();

    return (
      postDate.getMonth() === now.getMonth() &&
      postDate.getFullYear() === now.getFullYear()
    );
  };

  const isNewsPost = (post) => {
    return (
      post?.category?.slug === "tin-tuc" ||
      post?.category?.name === "Tin tức" ||
      post?.categoryId === 4
    );
  };

  const groupPostsByCategory = (posts) => {
    let filteredPosts = posts;

    if (currentMonthOnly) {
      const newsPosts = filteredPosts.filter((post) => isNewsPost(post));

      return {
        [`Tin tức tháng ${currentMonth}`]: newsPosts.filter((post) =>
          isPostInCurrentMonth(post),
        ),

        "Tin tức khác": newsPosts.filter(
          (post) => !isPostInCurrentMonth(post),
        ),
      };
    }

    if (categoryType) {
      const categoryTypeNames = new Set(
        categoryTypeItems.map((item) => item.name),
      );

      const categoryTypeSlugs = new Set(
        categoryTypeItems.map((item) => item.slug),
      );

      if (!slug) {
        if (categoryTypeItems.length > 0) {
          filteredPosts = posts.filter(
            (post) =>
              post?.category?.type === categoryType ||
              categoryTypeNames.has(post?.category?.name) ||
              categoryTypeSlugs.has(post?.category?.slug),
          );
        }
      } else {
        filteredPosts = posts.filter(
          (post) =>
            convertToSlug(post?.category?.name || "") === slug ||
            post?.category?.slug === slug,
        );
      }
    } else {
      // Nếu slug undefined, lọc các bài viết có category nằm trong navbars

      if (!slug) {
        const navbarCategories = new Set(navbars.map((item) => item.name));

        filteredPosts = posts.filter(
          (post) => !navbarCategories.has(post?.category?.name),
        );
      }
    }

    return filteredPosts.reduce((acc, post) => {
      const categoryName = post?.category?.name || "Chưa phân loại";

      if (!acc[categoryName]) {
        acc[categoryName] = [];
      }

      acc[categoryName].push(post);

      return acc;
    }, {});
  };

  const groupedPosts = groupPostsByCategory(posts);

  const displayedCategories = currentMonthOnly
    ? [`Tin tức tháng ${currentMonth}`, "Tin tức khác"]
    : categoryType && !slug && categoryTypeItems.length > 0
    ? categoryTypeItems.map((item) => item.name)
    : slug
    ? Object.keys(groupedPosts).filter(
        (categoryName) => convertToSlug(categoryName) === slug,
      )
    : Object.keys(groupedPosts);

  return (
    <div className="container mx-auto">
      <nav className="flex text-gray-500 text-sm mb-4" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2 flex-wrap">
          <li className="inline-flex items-center">
            <Link
              to="/"
              className="inline-flex items-center hover:text-blue-600 font-medium"
            >
              <HomeIcon className="w-4 h-4 mr-2 text-gray-400" />
              Trang chủ
            </Link>
          </li>

          <li>
            <div className="flex items-center">
              <svg
                className="w-3 h-3 mx-2 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M7.05 4.05a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L11.19 10 7.05 5.91a.75.75 0 010-1.06z" />
              </svg>

              <span className="ml-1 text-gray-400 font-medium">
                {pageTitle}
              </span>
            </div>
          </li>
        </ol>
      </nav>

      <div className="grid grid-cols-12 gap-4 mt-3 mb-2">
        <div className="col-span-12 md:col-span-12">
          {displayedCategories?.length > 0 ? (
            displayedCategories.map((categoryName) => (
              <div key={categoryName} className="mb-4">
                <h2 className="font-bold mb-4">
                  <ActivitiesButtonTitle title={categoryName} />
                </h2>

                {groupedPosts[categoryName]?.length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {groupedPosts[categoryName].map((article) => (
                      <ActivitiesArticleBoxByCategory
                        key={article.id}
                        article={article}
                      />
                    ))}
                  </div>
                ) : (
                  <p className="text-center my-10">Không có bài viết</p>
                )}
              </div>
            ))
          ) : (
            <p className="text-center my-10">Không có bài viết</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default News;